<template>
    <div class="JobStatus">
        <div class="main">
            <p class="title">求职状态<span class="sign">必填</span></p>
            <div v-show="JobStatusshowed"
                 class="JobStatus-main">
                <div class="flex">
                    <span>工作地点</span>
                    <span>{{ruleForm.areaName}}</span>
                </div>
                <div class="flex">
                    <span>期望月薪</span>
                    <span>{{ruleForm.salaryName}}</span>
                </div>
                <div class="flex">
                    <span>当前状态</span>
                    <span>{{ruleForm.stateName}}</span>
                </div>
                <i class="el-icon-edit-outline"
                   @click="changeJobStatus()"></i>
            </div>
            <el-form v-show="!JobStatusshowed"
                     :model="ruleForm"
                     :rules="rules"
                     ref="ruleForm"
                     :inline="true"
                     label-position="top"
                     label-width="100px"
                     class="demo-ruleForm">
                <el-form-item label="期望地点"
                              prop="areaId">
                    <!-- <el-input v-model="ruleForm.areaId"></el-input> -->
                    <el-cascader :options="options"
                                 :props="props"
                                 filterable
                                 v-model="ruleForm.areaId">
                    </el-cascader>
                </el-form-item>
                <el-form-item label="期望月薪"
                              prop="salary">
                    <el-select v-model="ruleForm.salary"
                               placeholder="请选择期望月薪">
                        <el-option v-for="(item,index) in salarylist"
                                   :key="index"
                                   :label="item.label"
                                   :value="item.value"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="当前状态"
                              prop="state">
                    <el-select v-model="ruleForm.state"
                               placeholder="请选择当前状态">
                        <el-option v-for="(item,index) in statelist"
                                   :key="index"
                                   :label="item.label"
                                   :value="item.value"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item v-show="JobStatusbtn"
                              style=" display:block;
                                    text-align:center;
                                    margin:26px 0;">
                    <el-button type="primary"
                               @click="subitJobStatus('ruleForm')">保存</el-button>
                    <el-button @click="quxiaoJobStatus('ruleForm')">取消</el-button>
                </el-form-item>
            </el-form>
        </div>
    </div>
</template>
<script>
import {
    selectsalarytype,
    selectworkStatetype,
    queryprovinceandcity
} from "@/api/homePage";
import { statusjob, selectstatusjob } from "@/api/apiall";
export default {
    data() {
        return {
            JobStatusbtn: false,
            JobStatusshowed: true,
            salarylist: [],
            statelist: [],
            options: [],
            props: {
                label: "name",
                value: "code",
                children: "child"
            },
            ruleForm: {
                id: "",
                userId: "",
                areaId: [],
                salary: "",
                state: ""
            },
            rules: {
                areaId: [
                    {
                        required: true,
                        message: "请输入期望地点",
                        trigger: "change"
                    }
                ],
                salary: [
                    {
                        required: true,
                        message: "请选择期望月薪",
                        trigger: "change"
                    }
                ],
                state: [
                    {
                        required: true,
                        message: "请选择当前状态",
                        trigger: "change"
                    }
                ]
            }
        };
    },
    watch: {
        $route(to, from) {
            if (to.path == "/Curriculumvitae") {
                this.JobStatusshowed = true;
                this.JobStatusbtn = true;
            } else {
                this.JobStatusshowed = false;
                this.JobStatusbtn = false;
            }
        }
    },
    created() {
        if (this.$route.path == "/Curriculumvitae") {
            this.JobStatusshowed = true;
            this.JobStatusbtn = true;
        } else {
            this.JobStatusshowed = false;
            this.JobStatusbtn = false;
        }
        this.search();
        this.qurry();
        this.querycity();
        // if (
        //     sessionStorage.getItem("userId") != null ||
        //     sessionStorage.getItem("userId") != undefined
        // ) {
        //     this.searchJobStatus();
        // }
    },
    methods: {
        querycity() {
            queryprovinceandcity({ code: "-1" }).then(res => {
                if (res.status === 2000) {
                    this.options = res.data;
                }
            });
        },
        search() {
            selectsalarytype().then(res => {
                if (res.status === 2000) {
                    this.salarylist = res.data;
                }
            });
        },
        qurry() {
            selectworkStatetype().then(res => {
                if (res.status === 2000) {
                    this.statelist = res.data;
                }
            });
        },
        searchJobStatus() {
            this.ruleForm.userId = sessionStorage.getItem("userId");
            selectstatusjob({ userId: this.ruleForm.userId }).then(res => {
                if (res.status === 2000) {
                    if (res.data) {
                        this.ruleForm = res.data;
                        this.ruleForm.areaId = res.data.area;
                    } else {
                        this.JobStatusshowed = false;
                    }
                } else {
                    this.JobStatusshowed = false;
                }
            });
        },
        changeJobStatus() {
            this.JobStatusshowed = false;
        },
        subitJobStatus(formName) {
            this.$refs[formName].validate(valid => {
                if (valid) {
                    this.ruleForm.userId = sessionStorage.getItem("userId");
                    this.ruleForm.id = sessionStorage.getItem("informationId");
                    statusjob(this.ruleForm).then(res => {
                        if (res.status === 2000) {
                            this.$message({
                                message: "提交成功",
                                type: "success"
                            });
                            this.JobStatusshowed = true;
                            this.searchJobStatus();
                        } else {
                            this.$message({
                                message: res.data,
                                type: "warning"
                            });
                        }
                    });
                } else {
                    console.log("error submit!!");
                    return false;
                }
            });
        },
        quxiaoJobStatus(formName) {
            this.JobStatusshowed = true;
            this.$refs[formName].resetFields();
            this.searchJobStatus();
        },
        handleSubmit(formName) {
            this.$refs[formName].validate(valid => {
                if (valid) {
                    this.$emit("JobStatusByValue", this.ruleForm);
                } else {
                    console.log("error submit!!");
                    return false;
                }
            });
        }
    }
};
</script>


<style scoped lang="scss">
.JobStatus {
    width: 900px;
    background-color: #fff;
    float: left;
    .main {
        padding: 30px;
        border-bottom: 1px solid #ddd;
        .JobStatus-main {
            position: relative;
            width: 100%;
            display: flex;
            .flex {
                flex: 1;
                span {
                    display: block;
                    line-height: 24px;
                }
                span:nth-child(1) {
                    margin-top: 20px;
                    color: #666;
                    font-size: 14px;
                }
                span:nth-child(2) {
                    color: #000;
                    font-size: 15px;
                }
            }
            .el-icon-edit-outline {
                cursor: pointer;
                color: #fabe00;
                font-size: 25px;
                position: absolute;
                right: 20px;
                bottom: 0px;
            }
        }
        .title {
            font-size: 18px;
            color: #333;
        }
        .sign {
            display: inline-block;
            margin-left: 12px;
            position: relative;
            top: -2px;
            width: 37px;
            height: 18px;
            color: #fff;
            background-color: #fabe00;
            text-align: center;
            line-height: 16px;
            font-size: 12px;
            border-radius: 4px;
        }
        .el-form {
            margin-top: 20px;
            margin-bottom: 20px;
            .el-input,
            .el-cascader,
            .el-select {
                width: 230px;
            }
            /deep/ .el-form-item {
                margin-bottom: 6px !important;
                .el-form-item__label {
                    padding: 0 !important;
                }
            }
        }
        .el-form--label-top .el-form-item__label {
            padding: 0;
        }
        .el-form--inline .el-form-item {
            margin-right: 30px;
        }
    }
}
</style>
